export default (properties) => {
  const preferredVideoCodecs = properties?.preferredVideoCodecs;
  if (!preferredVideoCodecs) {
    return true;
  }
  if (typeof preferredVideoCodecs === 'string') {
    return preferredVideoCodecs.toLowerCase() === 'automatic';
  }
  if (Array.isArray(preferredVideoCodecs)) {
    return (
      preferredVideoCodecs.length > 0 &&
      preferredVideoCodecs.every(c => /^(vp8|vp9|h264)$/i.test(String(c)))
    );
  }
  return false;
};
